import { ref, onMounted } from 'vue'

const BASE = process.env.VUE_APP_BACK_END_API_BASE_URL

/**
 * Читает блок контента, который редактируется в админке.
 *
 * Если API недоступен или блок ещё не заполнен, остаётся значение по
 * умолчанию — страница не должна пустеть из-за проблем с сервером.
 *
 * @param {string} entity   имя блока, например 'ourValue'
 * @param {Array}  fallback что показывать, пока данных нет
 */
export function useContent(entity, fallback = []) {
  const items = ref(fallback)
  const loaded = ref(false)

  const load = async () => {
    try {
      const response = await fetch(`${BASE}/frontend/content/${entity}`, {
        headers: { Accept: 'application/json' },
      })

      if (!response.ok) return

      const body = await response.json()

      if (Array.isArray(body.data) && body.data.length) {
        items.value = body.data
      }
    } catch (error) {
      // сеть недоступна — показываем то, что было
    } finally {
      loaded.value = true
    }
  }

  onMounted(load)

  return { items, loaded, load }
}

/** То же самое для блока, который существует в единственном экземпляре. */
export function useContentSingle(entity, fallback = {}) {
  const { items, loaded, load } = useContent(entity, [fallback])
  const item = ref(fallback)

  const sync = () => {
    item.value = items.value[0] ?? fallback
  }

  return {
    item,
    items,
    loaded,
    load: async () => {
      await load()
      sync()
    },
  }
}
